"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (model, calc) {
  var fn = function fn(buf, previous) {
    return calc(buf, previous) >>> 0;
  };
  fn.signed = calc;
  fn.unsigned = fn;
  fn.model = model;

  return fn;
};


//////////////////
// WEBPACK FOOTER
// ./~/crc/lib/define_crc.js
// module id = 453
// module chunks = 951